import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { AppLayout } from '../layouts/AppLayout'
import { ProtectedRoute } from '../components/ui/ProtectedRoute'
import { LandingPage } from '../pages/LandingPage'
import { OfflineQueuePage } from '../pages/OfflineQueuePage'
import { LoginPage } from '../pages/LoginPage'
import { EsqueciSenhaPage } from '../pages/EsqueciSenhaPage'
import { RedefinirSenhaPage } from '../pages/RedefinirSenhaPage'
import { DashboardPage } from '../pages/DashboardPage'
import { InscricaoPublicaPage } from '../pages/InscricaoPublicaPage'
import { InscritosPublicoPage } from '../pages/InscritosPublicoPage'
import { ResultadosPublicoPage } from '../pages/ResultadosPublicoPage'
import { TvResultadosPage } from '../pages/TvResultadosPage'
import { ClubesPage } from '../modules/clubes/pages/ClubesPage'
import { AtiradorPage } from '../modules/atiradores/pages/AtiradorPage'
import { EnviarConvitesPage } from '../modules/atiradores/pages/EnviarConvitesPage'
import { ArmasPage } from '../modules/armas/pages/ArmasPage'
import { MinhasArmasPage } from '../modules/armas/pages/MinhasArmasPage'
import { CampeonatosPage } from '../modules/campeonatos/pages/CampeonatosPage'
import { ModalidadesPage } from '../modules/modalidades/pages/ModalidadesPage'
import { EtapasPage } from '../modules/etapas/pages/EtapasPage'
import { InscricoesPage } from '../modules/inscricoes/pages/InscricoesPage'
import { MinhasInscricoesPage } from '../modules/inscricoes/pages/MinhasInscricoesPage'
import { ConsultaInscricoesPage } from '../modules/inscricoes/pages/ConsultaInscricoesPage'
import { ProvasPendentesPage } from '../modules/inscricoes/pages/ProvasPendentesPage'
import { ResultadosPage } from '../modules/resultados/pages/ResultadosPage'
import { IpscPage } from '../modules/ipsc/pages/IpscPage'
import { RankingsPage } from '../modules/rankings/pages/RankingsPage'
import { RelatoriosPage } from '../modules/relatorios/pages/RelatoriosPage'
import { DeclaracoesPage } from '../modules/declaracoes/pages/DeclaracoesPage'
import { FinanceiroPage } from '../modules/financeiro/pages/FinanceiroPage'
import { GaleriaPage } from '../modules/galeria/pages/GaleriaPage'
import { AcessoPage } from '../modules/acesso/pages/AcessoPage'
import { HabitualidadePage } from '../modules/habitualidade/pages/HabitualidadePage'

const router = createBrowserRouter([
  // Rotas publicas
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/esqueci-senha', element: <EsqueciSenhaPage /> },
  { path: '/redefinir-senha', element: <RedefinirSenhaPage /> },
  { path: '/inscricao-publica', element: <InscricaoPublicaPage /> },
  { path: '/inscritos', element: <InscritosPublicoPage /> },
  { path: '/resultados-publico', element: <ResultadosPublicoPage /> },
  { path: '/tv', element: <TvResultadosPage /> },

  // Rotas protegidas
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/dashboard', element: <DashboardPage /> },
          { path: '/clubes', element: <ClubesPage /> },
          { path: '/atiradores', element: <AtiradorPage /> },
          { path: '/convites', element: <EnviarConvitesPage /> },
          { path: '/armas', element: <ArmasPage /> },
          { path: '/minhas-armas', element: <MinhasArmasPage /> },
          { path: '/campeonatos', element: <CampeonatosPage /> },
          { path: '/modalidades', element: <ModalidadesPage /> },
          { path: '/etapas', element: <EtapasPage /> },
          { path: '/inscricoes', element: <InscricoesPage /> },
          { path: '/inscricoes/consulta', element: <ConsultaInscricoesPage /> },
          { path: '/inscricoes/pendentes', element: <ProvasPendentesPage /> },
          { path: '/minhas-inscricoes', element: <MinhasInscricoesPage /> },
          { path: '/resultados', element: <ResultadosPage /> },
          { path: '/ipsc', element: <IpscPage /> }, // 016_: pistas, squads, lancamento por pista e apuracao
          { path: '/rankings', element: <RankingsPage /> },
          { path: '/relatorios', element: <RelatoriosPage /> },
          { path: '/declaracoes', element: <DeclaracoesPage /> },
          { path: '/financeiro', element: <FinanceiroPage /> },
          { path: '/galeria', element: <GaleriaPage /> },
          { path: '/acesso', element: <AcessoPage /> },
          { path: '/habitualidade', element: <HabitualidadePage /> },
          { path: '/offline-queue', element: <OfflineQueuePage /> },
        ],
      },
    ],
  },

  // Fallback
  { path: '*', element: <Navigate to="/" replace /> },
])

export function AppRouter() {
  return <RouterProvider router={router} />
}
